
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    class PageinoutstockrecordRequest extends PageRequest {
        stockProductId: number;
        productStockType: number;
        constructor() {
            super();
            this.productStockType = 1;
        }
    }
    @Component
    export default class LookmodelModule extends AbpBase {
        editModalShow: boolean = false;
        supplyModalShow: boolean = false;
        pagerequest: PageinoutstockrecordRequest = new PageinoutstockrecordRequest();
        IsCheckedStatus = Enums.getEnum(Enums.IsCheckStatus, true);
        creationTime: Date[] = [];
        createModalShow: boolean = false;
        deleteData: boolean = false;

        @Prop({ type: Boolean, default: false }) value: boolean;
        selectDate: string = "";
        selectDates: string = "";
        addLoding = false;
        siteType = Enums.SiteSType;
        whetherLocalList = Enums.WhetherLocal;
        amountTotal: string = '';;
        isShow: boolean;
        get list() {
            return this.$store.state.inoutstockrecord.list;
        };
        get loading() {
            return this.$store.state.inoutstockrecord.loading;
        }
        cancel() {
            (this.$refs.skuForm as any).resetFields();
            this.$emit('input', false);
        }
        pageChange(page: number) {
            this.$store.commit('inoutstockrecord/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('inoutstockrecord/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.user.currentPage = 1;
            this.getpage();
        }
        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            this.pagerequest.stockProductId = this.$store.state.backstockproduct.id;
            await this.$store.dispatch({
                type: 'inoutstockrecord/getInOutStockRecordList',
                data: this.pagerequest
            })

        }
        get pageSize() {
            return this.$store.state.inoutstockrecord.pageSize;
        }
        get totalCount() {
            return this.$store.state.inoutstockrecord.totalCount;
        }
        get currentPage() {
            return this.$store.state.inoutstockrecord.currentPage;
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.getpage();
                //var b = this.$store.state.frontstockproduct.id;
                //alert(b);
                //this.$set(this.pagerequest, "id", this.$store.state.frontstockproduct.id);
            }
        }
        async created() {


        }
        columns = [
            {
                title: '入库类型',
                key: 'productInStockType',
                width: 200,
                render: (h: any, params: any) => {
                    return h('span', Enums.ProductInStockType.filter(function (item) { return item.value == params.row.productInStockType })[0].name);
                }
            },
            {
                title: '入库数量',
                key: 'productChangeStockNums',
                width: 185,
            },
            {
                title: '剩余库存量',
                key: 'laveStockNums',
                width: 185,
            },
            {
                title: '入库时间',
                key: 'productInStockTime',
                width: 195,
                render: (h: any, params: any) => {
                    return h('span', params.row.productInStockTime ? DateUtils.formatLongDate(new Date(params.row.productInStockTime)) : '');
                }
            },
        ]
    }


